import { Image, UseHoverCardProps } from "@chakra-ui/react"
import { IconName } from "@pathwright/pathicons"
import { LightMode } from "@pathwright/ux/src/components/chakra/ui/color-mode"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import PackageProvider, {
  usePackageContext,
  type PackageProviderProps
} from "./PackageProvider"
import { PackagePopover, getPackageName } from "./PackageUI"

const PackageBadge = ({
  positioning
}: {
  positioning?: UseHoverCardProps["positioning"]
}) => {
  const { packageData, theme } = usePackageContext()
  const { t } = useTranslate()

  const imageSize = "1.6rem"

  if (!packageData || (!packageData.image && !packageData.pathicon)) {
    return null
  }

  return (
    <PackagePopover
      positioning={positioning}
      renderTrigger={(Trigger) => (
        <LightMode>
          <Trigger
            aria-label={t("package_ui.view_details_for", {
              packageName: getPackageName(packageData),
              defaultValue: `View package details for ${getPackageName(
                packageData
              )}`
            })}
            type="button"
            cursor="pointer"
          >
            {packageData.image ? (
              <Image
                src={packageData.image || ""}
                alt={`${getPackageName(packageData)} logo`}
                w={imageSize}
                h={imageSize}
                m={0}
                borderRadius="5px"
                objectFit="cover"
              />
            ) : (
              <Pathicon
                icon={packageData.pathicon as IconName}
                size={imageSize}
                color={theme.primaryColor}
                m={0}
              />
            )}
          </Trigger>
        </LightMode>
      )}
    />
  )
}

type PackageBadgeProps = {
  positioning?: UseHoverCardProps["positioning"]
} & Omit<PackageProviderProps, "variant" | "actionButton" | "children">

const PackageBadgeContainer = ({
  positioning,
  ...providerProps
}: PackageBadgeProps) => {
  return (
    <PackageProvider variant="badge" {...providerProps}>
      <PackageBadge />
    </PackageProvider>
  )
}

export default PackageBadgeContainer
